import React from "react";
import styled from "styled-components";
import { PathwayFormGrid } from "../../_UI/StyledComponents/PathwayForm";
import PathwaySwitchInputGroup from "../../_UI/Components/Inputs/PathwaySwitchInputGroup";
import { Paragraph } from "../../_UI/StyledComponents/StyledComponents";
import PathwayTextInputGroup from "../../_UI/Components/Inputs/PathwayTextInputGroup";
import { LoadingSpinnerButton } from "../../_UI/Components/PathwayButtons";
import { useSelector } from "react-redux";
import { ErrorMessage } from "../../_UI/Components/Alerts/PathwayAlertMessages";
import PhoneNumberInput from "../../_components/PhoneNumberInput";

const TikTokAppstoreNewUserRegistration = (props) => {
    const appstoreSetup = useSelector((state) => state.appstoreSetup);
    return (
        <UserGrid>
            <PathwayFormGrid>
                <PathwayTextInputGroup
                    label={"Name des Unternehmens"}
                    name={"organizationName"}
                    handleChange={props.handleChange}
                    value={props.newOrgAndUser.organizationName}
                    dataCy="organization-name-registration-input"
                />
                <PathwayTextInputGroup
                    label={"Vorname"}
                    name={"firstName"}
                    dataCy="user-firstname-registration-input"
                    handleChange={props.handleChange}
                    value={props.newOrgAndUser.firstName}
                    mandatory
                    autoFocus
                />
                <PathwayTextInputGroup
                    label={"Nachname"}
                    name={"lastName"}
                    dataCy="user-lastname-registration-input"
                    handleChange={props.handleChange}
                    value={props.newOrgAndUser.lastName}
                    mandatory
                />
                <div>
                    <PathwayTextInputGroup
                        label={"Email"}
                        name={"email"}
                        dataCy="user-email-registration-input"
                        handleChange={props.handleChange}
                        triggerOnBlur={props.handleEmailBlur}
                        value={props.newOrgAndUser.email}
                        mandatory
                    />
                    {props.emailError && <EmailErrorText>{props.emailError}</EmailErrorText>}
                </div>
                <PhoneNumberInput {...props.phoneInputProps} phoneInputDataCy="user-phone-registration-input" />
                <PathwayTextInputGroup
                    label={"Passwort"}
                    name={"password"}
                    type="password"
                    dataCy="user-password-registration-input"
                    handleChange={props.handleChange}
                    value={props.newOrgAndUser.password}
                    mandatory
                />
                <PathwayTextInputGroup
                    label={"Passwort wiederholen"}
                    name={"passwordRepeat"}
                    type="password"
                    dataCy="user-password-repeat-registration-input"
                    handleChange={props.handleChange}
                    value={props.newOrgAndUser.passwordRepeat}
                    mandatory
                />
            </PathwayFormGrid>
            <br />
            <ErrorMessage messages={appstoreSetup.shopifyNewUserError} />
            <LoginRow>
                <LoadingSpinnerButton
                    className="btn btn-block btn-primary"
                    onClick={props.submit}
                    loading={appstoreSetup.shopifyNewUserLoading}
                    disabled={!props.newOrgAndUser.acceptTos || !props.newOrgAndUser.acceptDpa}
                    buttonCyData="tiktok-user-registration-button"
                >
                    Jetzt registrieren
                </LoadingSpinnerButton>
                <br />
                <PathwaySwitchInputGroup
                    onChange={props.handleChange}
                    value={props.newOrgAndUser.acceptTos}
                    name="acceptTos"
                    dataCy="tiktok-accepttos-registration-input"
                    label={
                        <Paragraph>
                            Ich stimme der{" "}
                            <a
                                href={
                                    "https://app.pathway-solutions.de/Nutzungsvereinbarung_Platform.pdf"
                                }
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Nutzungsvereinbarung
                            </a>{" "}
                            in der derzeit gültigen Fassung zu.
                        </Paragraph>
                    }
                />
                <PathwaySwitchInputGroup
                    onChange={props.handleChange}
                    value={props.newOrgAndUser.acceptDpa}
                    name="acceptDpa"
                    dataCy="tiktok-acceptdpa-registration-input"
                    label={
                        <Paragraph>
                            Ich stimme dem Vertrag zur{" "}
                            <a
                                href={"https://app.pathway-solutions.de/AVV_Platform.pdf"}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Auftragsverarbeitung
                            </a>{" "}
                            zu.
                        </Paragraph>
                    }
                />
                <br />
            </LoginRow>
        </UserGrid>
    );
};

export default TikTokAppstoreNewUserRegistration;

const EmailErrorText = styled.span`
    color: #dc3545;
    font-size: 0.8rem;
    margin-top: 0.25rem;
    display: block;
`;

const UserGrid = styled.div`
    display: grid;
`;

const LoginRow = styled.div`
    display: grid;
    grid-template-columns: 1fr;
    align-items: center;
`;
